import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface AuditReportSubmission {
  reportId?: any
  reportType? : any;
  id: number
  auditReportId: number
  auditSubmissionJson: string
  submittedAt: string
  submittedBy: number
  status: string
  inActive: boolean
  inActiveReason: string
  inActiveBy: string
  inActiveDate: string | null
  addedBy: string
  addedDate: string
  updatedBy: string
  updatedDate: string
}

interface AuditReportSubmissionState {
  submissions: AuditReportSubmission[]
  loading: boolean
  error: string | null
}

const initialState: AuditReportSubmissionState = {
  submissions: [],
  loading: false,
  error: null
}

export const auditReportSubmissionSlice = createSlice({
  name: "auditReportSubmission",
  initialState,
  reducers: {
    setSubmissions: (state, action: PayloadAction<AuditReportSubmission[]>) => {
      state.submissions = action.payload
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    }
  }
})

export const { setSubmissions, setLoading, setError } = auditReportSubmissionSlice.actions

export default auditReportSubmissionSlice.reducer 